import * as Schema from '../../components/graphql/schema.graphql.d';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetBaseModelMetadataListQueryVariables = Schema.Exact<{ [key: string]: never; }>;


export type GetBaseModelMetadataListQueryResult = (
  { __typename?: 'Query' }
  & { baseModelMetadataList: Array<(
    { __typename?: 'BaseModelMetadata' }
    & Pick<Schema.BaseModelMetadata, 'id' | 'inferenceTimingRange'>
  )> }
);


export const GetBaseModelMetadataList = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBaseModelMetadataList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseModelMetadataList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inferenceTimingRange"}}]}}]}}]} as unknown as DocumentNode<GetBaseModelMetadataListQueryResult, GetBaseModelMetadataListQueryVariables>;